export { AdminQueryKeys } from './admin';
export {
  TasksQueryKeys,
  type TasksSearchKeyParams,
  type TasksSearchStatsKeyParams,
  type TasksSearchPostKeyParams,
} from './tasks';
export { PeopleQueryKeys } from './people';
export { AssetsQueryKeys } from './assets';
export { CommunicationQueryKeys } from './communication';
export { AutocompleteQueryKeys } from './autocomplete';
export { WebchatQueryKeys } from './webchat';
export { ExportsQueryKeys } from './exports';
export { PerfStatsQueryKeys } from './perfStats';
export { AccountQueryKeys } from './account';
export { ConfigQueryKeys } from './config';
export { MiscQueryKeys } from './misc';
export { pathKey } from './path';

import { AccountQueryKeys } from './account';
import { AdminQueryKeys } from './admin';
import { AssetsQueryKeys } from './assets';
import { AutocompleteQueryKeys } from './autocomplete';
import { CommunicationQueryKeys } from './communication';
import { ConfigQueryKeys } from './config';
import { ExportsQueryKeys } from './exports';
import { MiscQueryKeys } from './misc';
import { PeopleQueryKeys } from './people';
import { PerfStatsQueryKeys } from './perfStats';
import { TasksQueryKeys } from './tasks';
import { WebchatQueryKeys } from './webchat';

/**
 * Default export shape for `useQuery` / invalidation — one object tree to import everywhere.
 */
export const queryKeys = {
  admin: AdminQueryKeys,
  tasks: TasksQueryKeys,
  people: PeopleQueryKeys,
  assets: AssetsQueryKeys,
  communication: CommunicationQueryKeys,
  autocomplete: AutocompleteQueryKeys,
  webchat: WebchatQueryKeys,
  exports: ExportsQueryKeys,
  perfStats: PerfStatsQueryKeys,
  account: AccountQueryKeys,
  config: ConfigQueryKeys,
  misc: MiscQueryKeys,
};
